/* eslint-disable */
// Espejo de aws_lambdas/_shared_gastos/gastosRules.js para el SIMULADOR de ventas (cuerpo idéntico,
// lo fija aws_lambdas/_shared_gastos/gastosCopies.test.js). Se edita ALLÍ y se copia aquí.
// ── gastosRules: cuerpo compartido (inicio) ──
const GASTOS_LIMITS = Object.freeze({
  MAX_DOCS: 10, MAX_FILES_PER_DOC: 6, MAX_FILES: 20, MAX_FILE_BYTES: 10 * 1024 * 1024,
  MAX_PDF_PAGES: 15, MAX_PER_DAY: 5, MAX_SIDE_PX: 2000, JPEG_QUALITY: 0.85, POLL_MS: 2000,
  URL_TTL_S: 900, JOB_TTL_DAYS: 7, MAX_INVOICES_PER_DOC: 10, MAX_LINES: 200, MAX_REREADS: 3,
});
const CATEGORIES = ["material", "combustible", "suministros", "servicios", "alquiler", "otros"];
// Valores que se PROPONEN al elegir la categoría en el formulario (editables, nunca se fuerzan).
// Alquiler (7/10/2026, Bluecar): sin IVA (vivienda, o lo que diga la factura) y retención del 19 %
// sobre la base (tipo general de IRPF de los arrendamientos urbanos). Un local suele llevar IVA 21 %
// + retención 19 %: si la factura trae IVA, se respeta.
const CATEGORY_DEFAULTS = Object.freeze({ alquiler: Object.freeze({ iva_rate: 0, withholding_rate: 19 }) });
const PAYMENT_METHODS = ["tarjeta", "efectivo", "transferencia", "domiciliacion", "bizum", "otro"];
const ESTADOS = ["pagada", "pendiente"];
const SPANISH_IVA_RATES = [0, 4, 5, 10, 21];
const TOL_OK = 0.02;

function round2(n) { return Math.round((Number(n) + Number.EPSILON) * 100) / 100; }
function isNum(n) { return typeof n === "number" && Number.isFinite(n); }
function stripAccents(s) { return String(s == null ? "" : s).normalize("NFD").replace(/[̀-ͯ]/g, ""); }
function cleanText(v, max) {
  if (v === null || v === undefined) return "";
  const s = String(v).replace(/\s+/g, " ").trim();
  return max ? s.slice(0, max) : s;
}
function normalizeName(s) { return stripAccents(s).toLowerCase().replace(/[^a-z0-9]+/g, " ").trim(); }

// Importe → número con 2 decimales, o null. Coma decimal española por defecto.
function parseAmount(v) {
  if (v === null || v === undefined || v === "") return null;
  if (typeof v === "number") return Number.isFinite(v) ? round2(v) : null;
  let s = String(v).trim().toLowerCase().replace(/€|eur(os)?|%/g, "").replace(/\s/g, "");
  if (!s) return null;
  let neg = false;
  if (/^\(.*\)$/.test(s)) { neg = true; s = s.slice(1, -1); }
  if (s.endsWith("-")) { neg = true; s = s.slice(0, -1); }
  if (s.startsWith("-")) { neg = !neg; s = s.slice(1); }
  if (s.startsWith("+")) s = s.slice(1);
  const lastComma = s.lastIndexOf(",");
  const lastDot = s.lastIndexOf(".");
  if (lastComma >= 0 && lastDot >= 0) {
    if (lastComma > lastDot) s = s.replace(/\./g, "").replace(",", ".");
    else s = s.replace(/,/g, "");
  } else if (lastComma >= 0) {
    s = s.replace(/,(?=.*,)/g, "").replace(",", ".");
  } else if (/^\d{1,3}(\.\d{3})+$/.test(s)) {
    s = s.replace(/\./g, "");
  }
  if (!/^\d+(\.\d+)?$/.test(s)) return null;
  const n = round2(Number(s));
  return neg ? -n : n;
}

const DNI_LETTERS = "TRWAGMYFPDXBNJZSQVHLCKE";
function cleanNif(v) { return String(v == null ? "" : v).toUpperCase().replace(/[^A-Z0-9]/g, ""); }
function spanishNifStatus(n) {
  if (/^\d{8}[A-Z]$/.test(n)) return DNI_LETTERS[Number(n.slice(0, 8)) % 23] === n[8] ? "ok" : "invalid";
  if (/^[XYZ]\d{7}[A-Z]$/.test(n)) {
    const num = Number(String("XYZ".indexOf(n[0])) + n.slice(1, 8));
    return DNI_LETTERS[num % 23] === n[8] ? "ok" : "invalid";
  }
  if (/^[ABCDEFGHJKLMNPQRSUVW]\d{7}[0-9A-J]$/.test(n)) {
    const d = n.slice(1, 8).split("").map(Number);
    let sum = 0;
    d.forEach((x, i) => {
      if (i % 2 === 1) sum += x;
      else { const y = x * 2; sum += Math.floor(y / 10) + (y % 10); }
    });
    const ctrl = (10 - (sum % 10)) % 10;
    const c = n[8];
    const letter = "JABCDEFGHI"[ctrl];
    if ("PQRSWN".includes(n[0])) return c === letter ? "ok" : "invalid";
    if ("ABEH".includes(n[0])) return c === String(ctrl) ? "ok" : "invalid";
    return c === String(ctrl) || c === letter ? "ok" : "invalid";
  }
  return null;
}
// "ok" | "invalid" | "foreign" (NIF-IVA de otro país de la UE u otro formato extranjero) | "missing"
function validNif(v) {
  const n = cleanNif(v);
  if (!n) return "missing";
  const es = spanishNifStatus(n);
  if (es) return es;
  if (n.startsWith("ES")) return spanishNifStatus(n.slice(2)) || "invalid";
  if (/^[A-Z]{2}[A-Z0-9]{2,13}$/.test(n)) return "foreign";
  return "invalid";
}
function canonicalNif(v) {
  const n = cleanNif(v);
  if (n.startsWith("ES") && spanishNifStatus(n.slice(2)) === "ok") return n.slice(2);
  return n.slice(0, 20);
}

function normalizeDate(v) {
  if (!v) return null;
  const s = String(v).trim();
  let y; let m; let d;
  let mt = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (mt) { y = +mt[1]; m = +mt[2]; d = +mt[3]; } else {
    mt = s.match(/^(\d{1,2})[/.-](\d{1,2})[/.-](\d{2,4})$/);
    if (!mt) return null;
    d = +mt[1]; m = +mt[2]; y = +mt[3];
    if (y < 100) y += 2000;
  }
  const dt = new Date(Date.UTC(y, m - 1, d));
  if (dt.getUTCFullYear() !== y || dt.getUTCMonth() !== m - 1 || dt.getUTCDate() !== d) return null;
  return `${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
}

function mapPayment(v) {
  const s = normalizeName(v);
  if (!s) return null;
  if (PAYMENT_METHODS.includes(s)) return s;
  if (/tarjeta|card|visa|master|credit|debit|tpv|datafono/.test(s)) return "tarjeta";
  if (/efectivo|cash|metalico|contado|bar/.test(s)) return "efectivo";
  if (/domicili|recibo|direct debit|sepa|adeudo/.test(s)) return "domiciliacion";
  if (/transfer|bank|banco|wire|ingreso/.test(s)) return "transferencia";
  if (/bizum/.test(s)) return "bizum";
  return "otro";
}
function mapCategory(v) {
  const s = normalizeName(v);
  if (CATEGORIES.includes(s)) return s;
  if (/combust|gasolin|gasoil|gasoleo|diesel|carburant|fuel|petrol/.test(s)) return "combustible";
  if (/material|limpieza|producto|supplies|recambio|herramient|quimic|ferreter/.test(s)) return "material";
  if (/suministr|luz|agua|electric|energia|gas natural|telefon|internet|utilit/.test(s)) return "suministros";
  if (/alquiler|arrendamiento|arriendo|\brent\b|rental|\blease\b|renting/.test(s)) return "alquiler";
  if (/servicio|asesor|gestor|manten|reparac|seguro|publicidad|formacion|software|service/.test(s)) return "servicios";
  return "otros";
}
function mapDocType(v) {
  const s = normalizeName(v);
  if (/abono|rectific|credit|nota de credito|devoluc/.test(s)) return "abono";
  if (/ticket|simplific|receipt|recibo/.test(s)) return "ticket";
  return "factura";
}

function normTaxLine(t) {
  if (!t || typeof t !== "object") return null;
  const line = {
    rate: parseAmount(t.rate ?? t.iva_rate ?? t.tipo),
    base: parseAmount(t.base ?? t.base_imponible),
    tax: parseAmount(t.tax ?? t.cuota ?? t.iva),
    re_rate: parseAmount(t.re_rate),
    re: parseAmount(t.re),
  };
  if (line.rate === null && line.base === null && line.tax === null) return null;
  return line;
}
function normLine(l) {
  if (!l || typeof l !== "object") return null;
  const description = cleanText(l.description ?? l.concepto, 300);
  if (!description) return null;
  return {
    description,
    quantity: parseAmount(l.quantity ?? l.cantidad),
    unit_price: parseAmount(l.unit_price ?? l.precio),
    amount: parseAmount(l.amount ?? l.importe),
    iva_rate: parseAmount(l.iva_rate ?? l.rate),
  };
}

// Lo que devuelve la IA (anidado o plano) o lo que manda el formulario → forma canónica.
function normalizeExtraction(raw) {
  const r = raw && typeof raw === "object" && !Array.isArray(raw) ? raw : {};
  const sup = r.supplier && typeof r.supplier === "object" ? r.supplier : {};
  const whRaw = r.withholding && typeof r.withholding === "object" ? r.withholding : {};
  const conf = parseAmount(r.confidence);
  const paid = r.paid === true || r.paid === false ? r.paid : null;
  return {
    doc_type: mapDocType(r.doc_type),
    supplier_name: cleanText(r.supplier_name ?? sup.name, 200),
    supplier_nif: canonicalNif(r.supplier_nif ?? sup.nif),
    number: cleanText(r.number, 60),
    date: normalizeDate(r.date),
    due_date: normalizeDate(r.due_date),
    tax_lines: (Array.isArray(r.tax_lines) ? r.tax_lines : []).map(normTaxLine).filter(Boolean).slice(0, 10),
    base_total: parseAmount(r.base_total),
    tax_total: parseAmount(r.tax_total),
    re_total: parseAmount(r.re_total),
    withholding_rate: parseAmount(r.withholding_rate ?? whRaw.rate),
    withholding_amount: parseAmount(r.withholding_amount ?? whRaw.amount),
    total: parseAmount(r.total),
    payment_method: mapPayment(r.payment_method),
    paid,
    estado: ESTADOS.includes(r.estado) ? r.estado : null,
    category: mapCategory(r.category),
    lines: (Array.isArray(r.lines) ? r.lines : []).map(normLine).filter(Boolean).slice(0, GASTOS_LIMITS.MAX_LINES),
    pages: (Array.isArray(r.pages) ? r.pages : []).map((p) => parseInt(p, 10)).filter((p) => p >= 1 && p <= 500),
    currency: cleanText(r.currency, 3).toUpperCase() || "EUR",
    language: cleanText(r.language, 5).toLowerCase() || null,
    confidence: conf === null ? null : Math.max(0, Math.min(1, conf)),
    notes: (Array.isArray(r.notes) ? r.notes : []).map((n) => cleanText(n, 300)).filter(Boolean).slice(0, 5),
    notes_user: cleanText(r.notes_user, 1000),
  };
}

// La IA puede devolver { invoices:[…] } (varias facturas en un documento) o una sola plana.
function splitExtraction(raw) {
  if (!raw || typeof raw !== "object") return [];
  if (Array.isArray(raw.invoices)) return raw.invoices.filter((x) => x && typeof x === "object").slice(0, GASTOS_LIMITS.MAX_INVOICES_PER_DOC);
  return Object.keys(raw).length ? [raw] : [];
}

const warnTol = (expected) => Math.max(0.10, Math.abs(Number(expected) || 0) * 0.005);
function levelForDiff(diff, expected) {
  if (diff <= TOL_OK + 1e-9) return "ok";
  if (diff <= warnTol(expected) + 1e-9) return "warn";
  return "error";
}
function snapRate(r) {
  let best = null;
  for (const s of SPANISH_IVA_RATES) if (Math.abs(s - r) <= 0.3 && (best === null || Math.abs(s - r) < Math.abs(best - r))) best = s;
  return best;
}

// Retención (en el signo de la base) que lleva un borrador aún sin reconciliar: el importe si
// consta, si no base × tipo; 0 si no hay retención.
function whOf(d, base) {
  const sg = isNum(base) && base < 0 ? -1 : 1;
  if (isNum(d.withholding_amount) && d.withholding_amount !== 0) return sg * Math.abs(d.withholding_amount);
  if (isNum(d.withholding_rate) && d.withholding_rate !== 0 && isNum(base)) return round2((base * Math.abs(d.withholding_rate)) / 100);
  return 0;
}

// Reconciliación: devuelve { draft (copia corregida), checks:{campo:{level,code}}, level, fixes[] }.
function reconcile(input, opts = {}) {
  const d = normalizeExtraction(JSON.parse(JSON.stringify(input || {})));
  const checks = {};
  const fixes = [];
  const rank = { ok: 0, warn: 1, error: 2 };
  const flag = (field, level, code) => {
    if (level === "ok") return;
    const cur = checks[field];
    if (!cur || rank[level] > rank[cur.level]) checks[field] = { level, code };
  };

  // 1) Signo: abono o total negativo → todo en negativo.
  const neg = d.doc_type === "abono" || (isNum(d.total) && d.total < 0);
  if (neg) {
    let flipped = false;
    const toNeg = (v) => { if (isNum(v) && v > 0) { flipped = true; return -v; } return v; };
    d.tax_lines = d.tax_lines.map((t) => ({ ...t, base: toNeg(t.base), tax: toNeg(t.tax), re: toNeg(t.re) }));
    d.base_total = toNeg(d.base_total);
    d.tax_total = toNeg(d.tax_total);
    d.re_total = toNeg(d.re_total);
    d.total = toNeg(d.total);
    if (flipped) { fixes.push("signo_corregido"); flag("total", "warn", "signo_corregido"); }
    d.doc_type = "abono";
  }

  // 2) Tramos de IVA.
  if (!d.tax_lines.length) {
    if (isNum(d.base_total) && isNum(d.tax_total)) {
      const r = d.base_total ? round2((d.tax_total / d.base_total) * 100) : 0;
      d.tax_lines = [{ rate: snapRate(r) ?? r, base: d.base_total, tax: d.tax_total, re_rate: null, re: null }];
      flag("tax_lines", "warn", "tramo_deducido");
    } else if (isNum(d.base_total) && isNum(d.total) && (Math.abs(d.base_total - d.total) <= TOL_OK
      || Math.abs(d.base_total - whOf(d, d.base_total) - d.total) <= TOL_OK)) {
      // Sin IVA (exenta / no sujeta): total = base, o base − retención (alquiler sin IVA con IRPF).
      d.tax_lines = [{ rate: 0, base: d.base_total, tax: 0, re_rate: null, re: null }];
      flag("tax_lines", "warn", "tramo_deducido");
    } else {
      flag("tax_lines", "error", "sin_desglose");
    }
  }
  // IVA incluido: un solo tramo con tipo pero sin base ni cuota, y total conocido.
  if (d.tax_lines.length === 1 && isNum(d.total) && isNum(d.tax_lines[0].rate) && d.tax_lines[0].base === null && d.tax_lines[0].tax === null) {
    const t = d.tax_lines[0];
    const reRate = isNum(t.re_rate) ? t.re_rate : 0;
    // Con retención el total es base + IVA + RE − IRPF: se despeja la base contando con ella.
    const sg = d.total < 0 ? -1 : 1;
    const whAmt = isNum(d.withholding_amount) && d.withholding_amount !== 0 ? sg * Math.abs(d.withholding_amount) : null;
    const whRate = whAmt === null && isNum(d.withholding_rate) ? Math.abs(d.withholding_rate) : 0;
    const gross0 = whAmt === null ? null : d.total + whAmt;
    t.base = round2(gross0 !== null ? gross0 / (1 + (t.rate + reRate) / 100) : d.total / (1 + (t.rate + reRate - whRate) / 100));
    const gross = gross0 !== null ? gross0 : d.total + round2((t.base * whRate) / 100);
    t.tax = round2((t.base * t.rate) / 100);
    if (reRate) t.re = round2(gross - t.base - t.tax);
    else t.tax = round2(gross - t.base);
    fixes.push("iva_incluido_calculado");
    flag("tax_lines", "warn", "iva_incluido_calculado");
  }
  d.tax_lines = d.tax_lines.map((t0) => {
    const t = { rate: t0.rate, base: t0.base, tax: t0.tax, re_rate: t0.re_rate ?? null, re: t0.re ?? null };
    if (t.rate === null && isNum(t.base) && t.base !== 0 && isNum(t.tax)) {
      const r = round2((t.tax / t.base) * 100);
      t.rate = snapRate(r) ?? r;
      flag("tax_lines", "warn", "tipo_deducido");
    }
    if (t.rate === null) { flag("tax_lines", "error", "sin_tipo"); return t; }
    if (t.base === null && isNum(t.tax) && t.rate !== 0) {
      t.base = round2((t.tax * 100) / t.rate);
      flag("tax_lines", "warn", "base_calculada");
    }
    if (t.tax === null && isNum(t.base)) {
      t.tax = round2((t.base * t.rate) / 100);
      flag("tax_lines", "warn", "cuota_calculada");
    }
    if (!isNum(t.base) || !isNum(t.tax)) { flag("tax_lines", "error", "tramo_incompleto"); return t; }
    const expected = (t.base * t.rate) / 100;
    flag("tax_lines", levelForDiff(Math.abs(expected - t.tax), expected), "cuota_no_cuadra");
    if (!SPANISH_IVA_RATES.includes(t.rate)) flag("tax_lines", "warn", "tipo_no_espanol");
    if (isNum(t.re_rate) && t.re === null && isNum(t.base)) { t.re = round2((t.base * t.re_rate) / 100); flag("tax_lines", "warn", "recargo_calculado"); }
    if (isNum(t.re_rate) && isNum(t.re)) {
      const expRe = (t.base * t.re_rate) / 100;
      flag("tax_lines", levelForDiff(Math.abs(expRe - t.re), expRe), "recargo_no_cuadra");
    }
    return t;
  });

  // 3) Sumas de tramos.
  const complete = d.tax_lines.filter((t) => isNum(t.base) && isNum(t.tax));
  if (complete.length) {
    const sumBase = round2(complete.reduce((a, t) => a + t.base, 0));
    const sumTax = round2(complete.reduce((a, t) => a + t.tax, 0));
    const sumRe = round2(complete.reduce((a, t) => a + (isNum(t.re) ? t.re : 0), 0));
    if (isNum(d.base_total)) flag("base_total", levelForDiff(Math.abs(d.base_total - sumBase), sumBase), "suma_bases");
    if (isNum(d.tax_total)) flag("tax_total", levelForDiff(Math.abs(d.tax_total - sumTax), sumTax), "suma_cuotas");
    if (isNum(d.re_total) && d.re_total !== 0) flag("tax_total", levelForDiff(Math.abs(d.re_total - sumRe), sumRe), "suma_recargo");
    d.base_total = sumBase;
    d.tax_total = sumTax;
    d.re_total = sumRe;
  }

  // 4) Retención (IRPF): se guarda en magnitud con el signo de la base.
  const sign = isNum(d.base_total) && d.base_total < 0 ? -1 : 1;
  if (isNum(d.withholding_amount)) d.withholding_amount = sign * Math.abs(d.withholding_amount);
  if (isNum(d.withholding_rate)) d.withholding_rate = Math.abs(d.withholding_rate);
  if (isNum(d.withholding_rate) && d.withholding_rate > 0 && isNum(d.base_total)) {
    const expWh = round2((d.base_total * d.withholding_rate) / 100);
    if (!isNum(d.withholding_amount)) { d.withholding_amount = expWh; flag("withholding_amount", "warn", "irpf_calculado"); }
    else if (levelForDiff(Math.abs(expWh - d.withholding_amount), expWh) !== "ok") flag("withholding_amount", "warn", "irpf_no_cuadra");
  } else if (isNum(d.withholding_amount) && d.withholding_amount !== 0 && isNum(d.base_total) && d.base_total !== 0) {
    d.withholding_rate = round2((d.withholding_amount / d.base_total) * 100);
  }
  if (!isNum(d.withholding_amount)) d.withholding_amount = 0;
  if (!isNum(d.withholding_rate)) d.withholding_rate = 0;

  // 5) Total.
  if (isNum(d.base_total) && isNum(d.tax_total)) {
    const expected = round2(d.base_total + d.tax_total + (d.re_total || 0) - d.withholding_amount);
    if (!isNum(d.total)) { d.total = expected; flag("total", "warn", "total_calculado"); }
    else flag("total", levelForDiff(Math.abs(d.total - expected), expected), "total_no_cuadra");
  } else if (!isNum(d.total)) {
    flag("total", "error", "sin_total");
  }

  // 6) Líneas (informativas): por tipo de IVA deben sumar la base de su tramo.
  const withAmount = d.lines.filter((l) => isNum(l.amount));
  if (withAmount.length && complete.length) {
    const single = d.tax_lines.length === 1 ? d.tax_lines[0].rate : null;
    const byRate = {};
    let unknown = false;
    for (const l of withAmount) {
      const r = isNum(l.iva_rate) ? l.iva_rate : single;
      if (r === null) { unknown = true; break; }
      byRate[r] = round2((byRate[r] || 0) + l.amount);
    }
    let ok = true;
    if (unknown) {
      const s = round2(withAmount.reduce((a, l) => a + l.amount, 0));
      ok = Math.abs(s - d.base_total) <= Math.max(0.05, Math.abs(d.base_total) * 0.01);
    } else {
      const baseByRate = {};
      for (const t of complete) baseByRate[t.rate] = round2((baseByRate[t.rate] || 0) + t.base);
      const rates = new Set([...Object.keys(byRate), ...Object.keys(baseByRate)]);
      for (const r of rates) {
        const a = byRate[r] || 0;
        const b = baseByRate[r] || 0;
        if (Math.abs(a - b) > Math.max(0.05, Math.abs(b) * 0.01)) ok = false;
      }
    }
    if (!ok) flag("lines", "warn", "lineas_no_suman");
  }

  // 7) Cabecera.
  if (!d.supplier_name) flag("supplier_name", "error", "sin_proveedor");
  const nifSt = validNif(d.supplier_nif);
  if (nifSt === "missing") flag("supplier_nif", "warn", "sin_nif");
  else if (nifSt === "invalid") flag("supplier_nif", "warn", "nif_invalido");
  if (!d.number) flag("number", "warn", "sin_numero");
  if (!d.date) flag("date", "error", "sin_fecha");
  else if (opts.today) {
    const today = new Date(`${opts.today}T00:00:00Z`).getTime();
    const t = new Date(`${d.date}T00:00:00Z`).getTime();
    if (t > today + 86400000) flag("date", "warn", "fecha_futura");
    else if (t < today - 6 * 366 * 86400000) flag("date", "warn", "fecha_antigua");
  }
  if (d.currency && d.currency !== "EUR") flag("total", "warn", "moneda");

  const levels = Object.values(checks).map((c) => c.level);
  const level = levels.includes("error") ? "error" : levels.includes("warn") ? "warn" : "ok";
  return { draft: d, checks, level, fixes };
}

const AMOUNT_FIELDS = ["total", "base_total", "tax_total", "tax_lines"];

// Lo que se guarda. Rojo en importes → exige confirmedMismatch (el usuario lo confirma a mano).
function validateForSave(input, opts = {}) {
  const r = reconcile(input, opts);
  const d = r.draft;
  if (!d.supplier_name) return { ok: false, error: "supplier_required", checks: r.checks };
  if (!d.date) return { ok: false, error: "date_required", checks: r.checks };
  if (!isNum(d.total) && !d.tax_lines.length) return { ok: false, error: "amount_required", checks: r.checks };
  const amountError = AMOUNT_FIELDS.some((f) => r.checks[f] && r.checks[f].level === "error");
  if (amountError && !opts.confirmedMismatch) return { ok: false, error: "needs_confirmation", checks: r.checks };
  const estado = d.estado || (d.paid === false ? "pendiente" : "pagada");
  const gasto = {
    doc_type: d.doc_type, supplier_name: d.supplier_name, supplier_nif: d.supplier_nif, number: d.number,
    date: d.date, due_date: d.due_date, tax_lines: d.tax_lines, base_total: d.base_total ?? 0, tax_total: d.tax_total ?? 0,
    re_total: d.re_total ?? 0, withholding_rate: d.withholding_rate ?? 0, withholding_amount: d.withholding_amount ?? 0,
    total: isNum(d.total) ? d.total : 0, payment_method: d.payment_method, estado, category: d.category,
    lines: d.lines, currency: d.currency, notes_user: d.notes_user, amounts_confirmed: amountError ? true : undefined,
    check_level: r.level,
  };
  if (gasto.amounts_confirmed === undefined) delete gasto.amounts_confirmed;
  return { ok: true, gasto, checks: r.checks, level: r.level };
}

// Clave antiduplicados por proveedor + nº (NIF si lo hay, si no el nombre). null sin nº.
function dedupeNumberKey(g) {
  const num = String((g && g.number) || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
  if (!num) return null;
  const nif = canonicalNif(g && g.supplier_nif);
  const who = nif || normalizeName(g && g.supplier_name);
  if (!who) return null;
  return `${who}#${num}`;
}

// Totales de un listado (ignora borrados) con desglose por tipo de IVA.
function sumGastos(list) {
  const out = { count: 0, base: 0, iva: 0, re: 0, irpf: 0, total: 0, by_rate: [] };
  const by = {};
  for (const g of list || []) {
    if (!g || g.deleted) continue;
    out.count += 1;
    out.base += Number(g.base_total) || 0;
    out.iva += Number(g.tax_total) || 0;
    out.re += Number(g.re_total) || 0;
    out.irpf += Number(g.withholding_amount) || 0;
    out.total += Number(g.total) || 0;
    for (const t of g.tax_lines || []) {
      const k = Number(t.rate) || 0;
      if (!by[k]) by[k] = { rate: k, base: 0, iva: 0, re: 0 };
      by[k].base += Number(t.base) || 0;
      by[k].iva += Number(t.tax) || 0;
      by[k].re += Number(t.re) || 0;
    }
  }
  for (const k of ["base", "iva", "re", "irpf", "total"]) out[k] = round2(out[k]);
  out.by_rate = Object.values(by).sort((a, b) => a.rate - b.rate).map((x) => ({ rate: x.rate, base: round2(x.base), iva: round2(x.iva), re: round2(x.re) }));
  return out;
}

// Qué campos cambió el usuario respecto a lo que leyó la IA (para medir la precisión).
const DIFF_FIELDS = ["doc_type", "supplier_name", "supplier_nif", "number", "date", "tax_lines", "withholding_rate", "withholding_amount", "total", "payment_method", "category", "lines"];
function diffFields(aiDraft, saved) {
  const a = normalizeExtraction(aiDraft);
  const b = normalizeExtraction(saved);
  const canonTax = (x) => JSON.stringify((x || []).map((t) => [t.rate, t.base, t.tax, t.re_rate ?? null, t.re ?? null]).sort((p, q) => p[0] - q[0]));
  const canonLines = (x) => JSON.stringify((x || []).map((l) => [l.description, l.quantity, l.unit_price, l.amount, l.iva_rate]));
  const out = [];
  for (const f of DIFF_FIELDS) {
    let same;
    if (f === "tax_lines") same = canonTax(a.tax_lines) === canonTax(b.tax_lines);
    else if (f === "lines") same = canonLines(a.lines) === canonLines(b.lines);
    else if (f === "withholding_amount" || f === "withholding_rate") same = (a[f] || 0) === (b[f] || 0);
    else same = (a[f] ?? null) === (b[f] ?? null);
    if (!same) out.push(f);
  }
  return out;
}

function quarterRange(year, q) {
  const md = { 1: ["01-01", "03-31"], 2: ["04-01", "06-30"], 3: ["07-01", "09-30"], 4: ["10-01", "12-31"] }[Number(q)];
  if (!md) return null;
  return { from: `${year}-${md[0]}`, to: `${year}-${md[1]}`, label: `T${q} ${year}` };
}
function quarterOf(date) {
  const m = Number(String(date || "").slice(5, 7));
  return m >= 1 && m <= 12 ? Math.ceil(m / 3) : null;
}
// ── gastosRules: cuerpo compartido (fin) ──

export {
  GASTOS_LIMITS, CATEGORIES, CATEGORY_DEFAULTS, PAYMENT_METHODS, ESTADOS, SPANISH_IVA_RATES,
  round2, parseAmount, validNif, canonicalNif, normalizeDate, normalizeName, normalizeExtraction, splitExtraction,
  reconcile, validateForSave, dedupeNumberKey, sumGastos, diffFields, quarterRange, quarterOf,
};
